import customerCareType, { CustomerCareState, ICustomerCareAction } from "./customerCare.type";

const initialState: CustomerCareState = {
    contents: [],
    resultSave: null,
    isLoading: false,
    error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ICustomerCareAction) => {
    switch (action.type) {
        case customerCareType.INIT_CUSTOMER_CARE.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case customerCareType.INIT_CUSTOMER_CARE.SUCCESS:
            return {
                ...state,
                isLoading: false,
                contents: action.payload,
            };
        case customerCareType.INIT_CUSTOMER_CARE.ERROR:
            return {
                ...state,
                isLoading: false,
                contents: [],
                error: action.error,
            };

        case customerCareType.SAVE_CUSTOMER_CARE.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case customerCareType.SAVE_CUSTOMER_CARE.SUCCESS:
            return {
                ...state,
                isLoading: false,
                resultSave: action.payload,
            };
        case customerCareType.SAVE_CUSTOMER_CARE.CLEAN:
            return {
                ...state,
                isLoading: false,
                resultSave: null
            };
        case customerCareType.SAVE_CUSTOMER_CARE.ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
